import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, query, orderBy, limit, deleteDoc, doc, onSnapshot } from 'firebase/firestore';

const AdminShrine = ({ 
    pointUnit = 'RB', 
    shrineName, setShrineName,
    shrineBannerUrl, setShrineBannerUrl,
    shrineBgUrl, setShrineBgUrl,
    onSave // 親コンポーネントから保存関数を受け取る
}) => {
    // 掲示板の投稿リスト
    const [posts, setPosts] = useState([]);

    // 投稿（絵馬）をリアルタイム取得（監視用）
    useEffect(() => {
        const q = query(collection(db, "jinja_posts"), orderBy("createdAt", "desc"), limit(20));
        const unsub = onSnapshot(q, (snap) => {
            setPosts(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        return () => unsub();
    }, []);

    // 投稿削除機能（荒らし対策）
    const handleDeletePost = async (id) => {
        if(!window.confirm("この投稿を削除しますか？")) return;
        try {
            await deleteDoc(doc(db, "jinja_posts", id));
        } catch(e) {
            alert("削除失敗");
        }
    };

    return (
        <div className="card">
            <h3 style={{marginTop:0, fontSize:'18px', borderBottom:'1px solid #eee', paddingBottom:'10px'}}>⛩️ 神社設定 & 管理</h3>
            
            {/* --- デザイン設定エリア --- */}
            <div style={{background:'#f9f9f9', padding:'15px', borderRadius:'8px', marginBottom:'20px'}}>
                <h4 style={{margin:'0 0 10px 0', fontSize:'14px'}}>🎨 外観設定</h4>
                
                <div style={{marginBottom:'10px'}}>
                    {/* ★修正: 推奨サイズを追加 */}
                    <label style={{fontSize:'12px', fontWeight:'bold'}}>神社名 (またはロゴ画像URL) <span style={{color:'#d32f2f', fontWeight:'normal'}}>(推奨: 180x50px)</span></label>
                    <input 
                        type="text" 
                        value={shrineName} 
                        onChange={(e) => setShrineName(e.target.value)} 
                        placeholder="例: 勝守神社 または https://.../logo.png"
                        style={{width:'100%', padding:'8px', boxSizing:'border-box'}}
                    />
                    <div style={{fontSize:'10px', color:'#666', marginTop:'2px'}}>※URLを入力すると画像として表示されます</div>
                </div>
                
                <div style={{marginBottom:'10px'}}>
                    <label style={{fontSize:'12px', fontWeight:'bold'}}>トップバナー画像 URL <span style={{color:'#d32f2f', fontWeight:'normal'}}>(推奨: 1200x600px)</span></label>
                    <input 
                        type="text" 
                        value={shrineBannerUrl} 
                        onChange={(e) => setShrineBannerUrl(e.target.value)} 
                        placeholder="https://..."
                        style={{width:'100%', padding:'8px', boxSizing:'border-box'}}
                    />
                </div>

                <div style={{marginBottom:'10px'}}>
                    <label style={{fontSize:'12px', fontWeight:'bold'}}>背景画像 URL <span style={{color:'#d32f2f', fontWeight:'normal'}}>(推奨: 1920x1080px)</span></label>
                    <input 
                        type="text" 
                        value={shrineBgUrl} 
                        onChange={(e) => setShrineBgUrl(e.target.value)} 
                        placeholder="https://..."
                        style={{width:'100%', padding:'8px', boxSizing:'border-box'}}
                    />
                </div>
                
                {/* 保存ボタン */}
                <button 
                    onClick={onSave} 
                    style={{
                        width:'100%', padding:'12px', background:'#4caf50', color:'white', 
                        border:'none', borderRadius:'4px', cursor:'pointer', fontWeight:'bold',
                        marginTop:'10px', fontSize:'14px', boxShadow:'0 2px 5px rgba(0,0,0,0.2)'
                    }}
                >
                    設定を保存する
                </button>
            </div>

            {/* --- 投稿管理エリア --- */}
            <div style={{marginBottom:'20px'}}>
                <h4 style={{fontSize:'14px'}}>💬 最新の投稿 (削除管理)</h4>
                <div style={{maxHeight:'300px', overflowY:'auto', border:'1px solid #eee', borderRadius:'4px', background:'white'}}>
                    {posts.map(post => (
                        <div key={post.id} style={{padding:'8px', borderBottom:'1px solid #f0f0f0', display:'flex', justifyContent:'space-between', alignItems:'center', background: post.type === 'exorcism' ? '#f3e5f5' : '#fff'}}>
                            <div style={{fontSize:'12px'}}>
                                <span style={{fontWeight:'bold', marginRight:'5px'}}>
                                    {post.type === 'wish' ? '🙏 祈願' : '⚡ 厄除'}
                                </span>
                                {/* 管理者は realName があればそれを表示 (なければ displayName) */}
                                <span style={{color:'#333', fontWeight:'bold', marginRight:'5px'}}>
                                    {post.realName ? post.realName : (post.displayName || '不明')}
                                </span>
                                <div>{post.text}</div>
                            </div>
                            <button onClick={() => handleDeletePost(post.id)} style={{background:'#ff5252', color:'white', border:'none', borderRadius:'4px', padding:'4px 8px', cursor:'pointer', fontSize:'10px'}}>
                                削除
                            </button>
                        </div>
                    ))}
                    {posts.length === 0 && <div style={{padding:'10px', fontSize:'12px', color:'#999'}}>投稿なし</div>}
                </div>
            </div>
        </div>
    );
};

export default AdminShrine;